import React, { useState } from 'react'

import "./Form.css"

import Input from './Input'
import Dropdown from './Dropdown'
import { useTranslate } from '../../Context/LanguageContext'
import axios from 'axios';

import {ReactComponent as Check} from '../../assets/icons/check.svg'
import {ReactComponent as Error} from '../../assets/icons/error.svg'
import {ReactComponent as Watch} from '../../assets/icons/watch.svg'
import Checkbox from './Checkbox';

const api = axios.create({
  baseURL: '/', 
  headers: {
    'Content-Type': 'application/json'
  }
});

const Form = () => {
    const t = useTranslate("contact")
    const IDLE = 0;
    const LOAD = 1;
    const SUCCESS = 2;
    const ERROR = 3;
    const TIMEOUT = 4;

    const [form, setForm] = useState({salutation: "", name: "", surname: "", email: "", phone: "", company: "", message: ""})
    const [formStatus, setStatus] = useState(IDLE);

    const handleChange = e => {
        setForm({ ...form, [e.target.id]: e.target.value });
    };

    const submit = async (e) => {
        e.preventDefault()
        setStatus(LOAD)
        try {
            await api.post('/api/contact', form);
            setStatus(SUCCESS);
            setForm({salutation: "", name: "", surname: "", email: "", phone: "", company: "", message: ""})
        } catch (err) {
            if(err.response?.status === 429){
                setStatus(TIMEOUT);
            }else{
                setStatus(ERROR);
            }
        }
    }

    return (
        <>

        {formStatus === IDLE && 
        <form onSubmit={submit}>

            <div className='line'>
                <Dropdown
                    placeholder={t("salutation") + "*"}
                    options={[t("mr"), t("mrs"), t("divers")]}
                    value={form.salutation}
                    onChange={(val) => setForm({ ...form, salutation: val })}
                    required
                />

                <Input id="name" label={t("name")} required value={form.name} onChange={handleChange}/>
            </div>

            <div className='line'>
                <Input id="surname" label={t("surname")} required value={form.surname} onChange={handleChange}/>
                <Input id="email" type="email" label="E-Mail" required value={form.email} onChange={handleChange}/>
            </div>

            <div className='line'>
                <Input id="phone" type="tel" label={t("phone")} value={form.phone} onChange={handleChange}/>
                <Input id="company" label={t("company")} required value={form.company} onChange={handleChange}/>
            </div>

            <div className="message-wrapper">
                <label className="message-label" htmlFor="message"> <span className={form.message.length > 1000 ? "disabled" : ""}>{form.message.length}</span> / 1000</label>
                <textarea id="message" placeholder={t("message")} value={form.message} onChange={handleChange}></textarea>
            </div>

            <div className='consent-wrapper'>
                <Checkbox id={"consent"} required/>
                <label htmlFor='consent'>{t("agreement")}</label>
            </div>
            <p>{t("required")}</p>
            
            <button className='submit btn filled' type='submit' disabled={form.message.length > 1000}> {t("send")} <span>→</span></button>
        </form>
        }

        {formStatus === LOAD && 
            <div className='loading'>
                <div/>
                <h2>{t("sending")}</h2>
            </div>
        }

        {formStatus > LOAD && 
            <div className='response'>
                <div>
                    {formStatus === SUCCESS && <Check/>}
                    {formStatus === ERROR && <Error/>}
                    {formStatus === TIMEOUT && <Watch/>}
                </div>

                {formStatus === SUCCESS && <h2> {t("success1")} <br/> {t("success2")} </h2>}
                {formStatus === ERROR && <h2> {t("error1")} <br/> {t("error2")} </h2>}
                {formStatus === TIMEOUT && <h2> {t("timeout1")} <br/> {t("timeout2")} </h2>}

                <button id='filled-btn' onClick={() => setStatus(IDLE)}><span>←</span> {t("return")} </button>
            </div>
        }

        </>
    )
}

export default Form
